require("./CauditList.less");

const React = require("react");

const QuestionType = require("~/types/Question.js").PropType;
const Comment = require("../Comment/Comment.jsx");
const Task = require("../Task/Task.jsx"); 
const DiskButton = require("../DiskButton/DiskButton.jsx");

const NewAnswerSelection = require("~/types/AnswerSelection.js").NewForCauditList;

const CauditList = React.createClass({
    propTypes: {
        Question: QuestionType.isRequired,
        OnAnswerChange: React.PropTypes.func.isRequired
    },
    getInitialState() {
        const hasAnswerSelections = (this.props.Question.AnswerSelections || []).length > 0;
        const expectedLength = this.props.Question.AnswerOptions.length;
        const lastIndex = expectedLength - 1;
        const minRowCount = this.props.Question.QuestionType.MinAnswerSelectionCount;

        if (hasAnswerSelections) {
            const asAnswerSelection = ((sel) => {
                if (typeof (sel.SelectionText || "") === "string") {
                    sel.SelectionText = [sel.SelectionText || ""];
                }

                const newSelections = this.GetRowValues(sel.SelectionText);

                const mapped = NewAnswerSelection(
                    sel.SelectionText,
                    sel.AdditionalComment,
                    sel.GUID,
                    sel.SelectionScoreValue);

                return mapped;
            });

            const selections = this.props.Question.AnswerSelections
                .map(asAnswerSelection);

            const withMissingEntries = this.GetSelectionsWithMissingEntries(selections);

            return {
                AnswerSelections: withMissingEntries,
                AdditionalComment: this.props.Question.AdditionalComment,
                Task: this.props.Question.Task
            };
        }
        else {
            const selections = this.GetSelectionsWithMissingEntries([]);

            return {
                AnswerSelections: selections,
                AdditionalComment: this.props.Question.AdditionalComment,
                Task: this.props.Question.Task, 
                ItemsWithDiscreps: []
            };
        }
    },
    render() {
        const showCommentField = this.props.Question.IncludeComment;

        return (<div className="cs-CauditList">
            <header className="cs-CauditList__question"
                dangerouslySetInnerHTML={{ __html: this.props.Question.DisplayHTML }} />
            <table id="table" className="cs-CauditList__table">
                {this.GetHeader()}
                {this.GetRows()}
                {this.GetFooter()}
            </table>
            {showCommentField
                && (<Comment OnChange={this.OnCommentChange} Comment={this.state.AdditionalComment} />)}
            <Task OnChange={this.OnTaskChange } Task={this.state.Task}></Task>
        </div>);
    },
    GetHeader() {
        const tableHeadings = this.props.Question.AnswerOptions.map(this.GetHeading);

        return (<thead className="cs-CauditList__thead">
            <tr>
                <td></td>
                {tableHeadings}
            </tr>
        </thead>);
    },
    GetFooter() {
        const numberOfColumns = this.props.Question.AnswerOptions.length;
        
        if (this.state.AnswerSelections.length >= this.props.Question.QuestionType.MaxAnswerSelectionCount) {
            return null;
        }

        return (<tfoot>
            <tr>
                <td></td>
                <td colSpan={numberOfColumns} className="cs-CauditList__add-row-box">
                    <button className="cs-CauditList__add-row-btn btn btn-success"
                            onClick={this.AddRow}>
                        Add Row
                    </button>
                </td>
            </tr>
        </tfoot>);
    },
    GetRows() {
        let rows = this.state.AnswerSelections.map(this.GetRow);

        return rows;
    },
    GetRow(selection, i) {
        let cols = this.props.Question.AnswerOptions.map((option, j) => {
            const cellChange = (e) => {
                const value = e.target.value;

                this.UpdateCell(value, i, j);
            }

            const value = selection.SelectionText[j] || "";

            if (j === 0) {
                const firstCol = this.GetFirstCol(i, j, value, option.DisplayText, cellChange);

                return firstCol;
            }
            else if (j === this.props.Question.AnswerOptions.length - 1) {
                const discrepsCol = this.GetDiscrepancyCol(
                    i, j, value, selection.HasDiscrepancies, option.DisplayText, cellChange);

                return discrepsCol;
            }
            else {
                const otherCol = this.GetOtherColumn(i, j, value, option.DisplayText, cellChange);

                return otherCol;
            }
        });

        const removeRow = () => {
            this.RemoveRow(i);
        };

        return (<tbody key={i } className="cs-CauditList__tbody">
            <tr key="{i}1">
            <td rowSpan="2" className="cs-CauditList__delete-box">
                <DiskButton className="btn btn-danger cs-CauditList__DeleteButton"
                            onClick={removeRow}
                            MarkClassName="glyphicon glyphicon-remove" />
            </td>
                {cols.slice(0, -1)}
            </tr>
            <tr key="{i}2">
                {cols[cols.length-1]}
            </tr>
        </tbody>);
    },
    GetFirstCol(i, j, value, displayText, onCellChange) {
        const setRef = (ref) => this.newRow = ref;

        return (<td key={i, j} className="cs-CauditList__data">
            <input className="form-control cs-CauditList__data__input"
                ref={setRef}
                value={value} onChange={onCellChange}
                placeholder={displayText} />
            <p className="cs-CauditList__data__input--print">
                {value}
            </p>
        </td>);
    },
    /**
     * hasDiscrepancies could be true, false, or null:
     *   true: highlight the "No" button
     *   false: highlight the "Yes" button
     *   null: don't highlight
     */
    GetDiscrepancyCol(i, j, value, hasDiscrepancies, placeholder, onCellChange) {
        const onHasDiscreps = () => {
            this.SetSelectionHasDiscrepancies(i);
        };

        const onNoDiscreps = (e) => {
            this.SetSelectionHasNoDiscrepancies(i, j);
        };
        
        const hasDiscrepsClass =
            hasDiscrepancies === true
            ? "btn cs-CauditList__has-discreps-btn--selected"
            : "btn cs-CauditList__has-discreps-btn";

        const noDiscrepsClass =
            hasDiscrepancies === false
            ? "btn cs-CauditList__has-discreps-btn--selected"
            : "btn cs-CauditList__has-discreps-btn";

        return (<td key={i, j} className="cs-CauditList__data" colSpan={j}>
            <div className="cs-CauditList__label">
                {hasDiscrepancies === true &&
                (<div className="cs-CauditList__discrep-box">
                    <label>
                        Discrepancies
                        <em className="cs-CauditList__instruction">
                            &nbsp;&nbsp;(If none, click "None")
                        </em>
                    </label>
                    <div className="input-group cs-CauditList__discrep-group">
                        <input className="form-control cs-CauditList__data__input"
                            value={value} onChange={onCellChange}
                            placeholder={placeholder} />
                        <span className="input-group-btn">
                            <button className="btn btn-warn"
                            onClick={onNoDiscreps}>
                                None
                            </button>
                        </span>
                    </div>
                </div>)}
                {!hasDiscrepancies &&
                    (<div className="cs-CauditList__discrep-box">
                        Are there any discrepancies?
                        <button className={hasDiscrepsClass}
                                onClick={onHasDiscreps}>
                            Yes
                        </button>
                        <button className={noDiscrepsClass}
                                onClick={onNoDiscreps}>
                            No
                        </button>
                </div>)}
            </div>
            <p className="cs-CauditList__data__input--print">
                {value}
            </p>
        </td>);
    },
    GetOtherColumn(i, j, value, displayText, onCellChange) {
        return (<td key={i, j} className="cs-CauditList__data">
            <input className="form-control cs-CauditList__data__input"
                    value={value} onChange={onCellChange}
                    placeholder={displayText}  />
            <p className="cs-CauditList__data__input--print">
                {value}
            </p>
        </td>);
    },
    GetHeading(answerOption, i) {
        if (i === this.props.Question.AnswerOptions.length - 1) {
            return;
        }
        return (<th key={answerOption.GUID} className="cs-CauditList__header">
            {answerOption.DisplayText}
        </th>)
    },
    GetRowValues(baseVals) {
        baseVals = baseVals || [];

        const row = this.props.Question.AnswerOptions.map((op, i) => {
            return baseVals[i] || "";
        });

        return row;
    },

    UpdateCell(newValue, rowID, columnID) {
        const newAnswers = this.state.AnswerSelections.slice();

        newAnswers[rowID].SelectionText[columnID] = newValue;

        this.props.OnAnswerChange(newAnswers, this.state.AdditionalComment);

        this.setState({
            AnswerSelections: newAnswers
        });
    },

    SetSelectionHasDiscrepancies(rowID) {
        const newAnswers = this.state.AnswerSelections.slice();

        newAnswers[rowID].HasDiscrepancies = true;

        this.setState({
            AnswerSelections: newAnswers
        });
    },

    SetSelectionHasNoDiscrepancies(rowID, columnID) {
        const newAnswers = this.state.AnswerSelections.slice();

        newAnswers[rowID].SelectionText[columnID] = "";
        newAnswers[rowID].HasDiscrepancies =
            newAnswers[rowID].SelectionText[0].length > 0
            ? false // "There are definitely no discrepancies"
            : null; // "We don't know yet."

        this.props.OnAnswerChange(newAnswers, this.state.AdditionalComment);

        this.setState({
            AnswerSelections: newAnswers
        });
    },

    AddRow() {
        if(this.state.AnswerSelections.length >= this.props.Question.QuestionType.MaxAnswerSelectionCount){
            return;
        }

        let answers = this.state.AnswerSelections.slice();

        const newCols = this.GetRowValues();

        answers.push(NewAnswerSelection(newCols));

        this.props.OnAnswerChange(answers, this.state.AdditionalComment);

        this.setState({
            AnswerSelections: answers
        },
        () => {
            this.newRow.focus();
        });
    },

    RemoveRow(i) {
        if(this.state.AnswerSelections.length <=
            this.props.Question.QuestionType.MinAnswerSelectionCount) {
            return;
        }

        if (this.state.AnswerSelections.length > i) {
            let rest = this.state.AnswerSelections.slice(i + 1, this.state.AnswerSelections.length);
            let answers = this.state.AnswerSelections.slice(0, i).concat(rest);

            if (answers.length === 0) {
                const newCols = this.GetRowValues();

                answers.push(NewAnswerSelection(newCols));
            }

            this.props.OnAnswerChange(answers, this.state.AdditionalComment);

            this.setState({
                AnswerSelections: answers
            });
        }
    },

    OnCommentChange(e) {
        this.props.OnAnswerChange(this.state.AnswerSelections, e.target.value, this.state.Task);

        this.setState({
            AdditionalComment: e.target.value
        });
    },

    OnTaskChange(e) { 
        this.props.OnAnswerChange(this.state.AnswerSelections, this.state.AdditionalComment, e.target.value);

        this.setState({
            Task: e.target.value
        })
    }, 

    GetSelectionsWithMissingEntries(selections) {
        let result = selections || [];

        while(result.length <
            this.props.Question.QuestionType.MinAnswerSelectionCount) {
            const newCols = this.GetRowValues();
            const newSelection = NewAnswerSelection(newCols);

            result.push(newSelection);
        }

        return result;
    }
});

module.exports = CauditList;


// WEBPACK FOOTER //
// ./src/components/CauditList/CauditList.jsx